import { FecImportMappingTab } from '../enums/fecImportMappingTab'
import type { FecMappingTabLoadState } from '../types/fecMappingTabLoadState'

interface IsFecMappingNextDisabledParams {
  accountMappings: FecMappingTabLoadState
  activeTab: FecImportMappingTab
  journals: FecMappingTabLoadState
  thirdPartyMappings: FecMappingTabLoadState
}

export const isFecMappingNextDisabled = ({
  accountMappings,
  activeTab,
  journals,
  thirdPartyMappings,
}: IsFecMappingNextDisabledParams): boolean => {
  const loadStateByTab: Partial<Record<FecImportMappingTab, FecMappingTabLoadState>> = {
    [FecImportMappingTab.ChartOfAccounts]: accountMappings,
    [FecImportMappingTab.Journals]: journals,
    [FecImportMappingTab.ThirdPartyAccounts]: thirdPartyMappings,
  }
  const loadState = loadStateByTab[activeTab]

  return Boolean(loadState?.isError || loadState?.isLoading)
}
